__turbopack_context__.v({
  "card": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__card",
  "cardsContainer": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__cardsContainer",
  "carousel": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__carousel",
  "copy": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__copy",
  "icon": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__icon",
  "image": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__image",
  "imageContainer": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__imageContainer",
  "inner": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__inner",
  "isSingleCard": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__isSingleCard",
  "root": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__root",
  "scrollAnchor": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__scrollAnchor",
  "textContainer": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__textContainer",
  "title": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__title",
  "titleContainer": "BlockSubNavCardGroupSection-module-scss-module__o7kGmq__titleContainer",
});
